import { render, staticRenderFns } from "./SeminarTicketsByChair.vue?vue&type=template&id=f6dc490a&scoped=true&"
import script from "./SeminarTicketsByChair.vue?vue&type=script&lang=js&"
export * from "./SeminarTicketsByChair.vue?vue&type=script&lang=js&"
import style0 from "./SeminarTicketsByChair.vue?vue&type=style&index=0&id=f6dc490a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dc490a",
  null
  
)

export default component.exports